import React from 'react';

import { QuestionMultiChoice, QuestionTypeV2 } from '../../../redux/types';
import ChoiceQuestionEditor from '../ChoiceQuestionEditor';

export type Props = {
  surveyId: number;
  sectionId?: number;
  question?: QuestionMultiChoice;
  addQuestion?: (dq: Omit<QuestionMultiChoice, 'id'>) => void
  updateQuestion?: (dq: QuestionMultiChoice) => void
  onCancelEdit?: () => void;
  disableHideAggregation?: boolean;
}

const MultiChoiceQuestionEditor: React.FC<Props> = ({
  surveyId,
  sectionId,
  question,
  addQuestion,
  updateQuestion,
  onCancelEdit,
  disableHideAggregation,
}: Props) => (
  <ChoiceQuestionEditor<QuestionMultiChoice>
    surveyId={surveyId}
    sectionId={sectionId}
    question={question}
    addQuestion={addQuestion}
    updateQuestion={updateQuestion}
    onCancelEdit={onCancelEdit}
    type={QuestionTypeV2.MultiChoice}
    disableHideAggregation={disableHideAggregation}
  />
);

export default MultiChoiceQuestionEditor;
